/**
 * Returns given errors, written in paragraphs (each error in separate paragraph)
 * @param errors {TmParsingError[]}
 * @constructor
 */
export default function LineByLineTextErrorsComponent({errors}) {
    return(
        <>
            {(errors) && (
                <>
                    {
                        errors.map((error, idx) => (
                                <p className={'m-1 p-0 text-danger small text-start'} key={idx}>
                                    {error.description}
                                </p>
                            ))
                    }
                </>
            )}
        </>
    )
}